var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowBackActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4376 8.10938H3.72435L11.9322 0.984375C12.0634 0.869531 11.9837 0.65625 11.8103 0.65625H9.73607C9.64466 0.65625 9.55794 0.689062 9.48997 0.747656L0.632941 8.43281C0.551821 8.50313 0.486763 8.59006 0.442175 8.68772C0.397588 8.78537 0.374512 8.89147 0.374512 8.99883C0.374512 9.10618 0.397588 9.21228 0.442175 9.30994C0.486763 9.40759 0.551821 9.49453 0.632941 9.56484L9.54153 17.2969C9.57669 17.3273 9.61888 17.3438 9.66341 17.3438H11.8079C11.9814 17.3438 12.0611 17.1281 11.9298 17.0156L3.72435 9.89062H17.4376C17.5408 9.89062 17.6251 9.80625 17.6251 9.70312V8.29688C17.6251 8.19375 17.5408 8.10938 17.4376 8.10938Z",
    fill: "#1f1c3c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackActive);
export default __webpack_public_path__ + "static/media/arrow-back-active.59ba35e0.svg";
export { ForwardRef as ReactComponent };